import Archive from './archive';
import Crypto from './crypto';
import HashTable from './hashtable';
import Hash from './hash';
import BlockTable from './blocktable';
import Block from './block';
import File from './file';
import { isArchive } from './isarchive';

export default {
  Archive,
  Crypto,
  HashTable,
  Hash,
  BlockTable,
  Block,
  File,
  isArchive,
};
